import { graphql } from '~/gql';
import { JobTemplateFields } from '~/graphql/fragment/JobTemplateFields';

/**
 * Shared mutation for updating a job template.
 * Returns the full template with all fields via JobTemplateFields fragment.
 */
export const UpdateJobTemplateDocument = graphql(`
  mutation UpdateJobTemplate($id: ID!, $input: JobTemplateInput!) {
    updateJobTemplate(id: $id, input: $input) {
      id
      ...JobTemplateFields
    }
  }
`);
